<template>
    <div class="tasks-info-table">
        <m-table ref="table"
                 class="target-table"
                 searchId="visual_dispatch_center_query"
                 pageID="visual_dispatch_center"
                 :tableConfig="config.table"
                 :tableData="totalData"
                 :tableList="tableColumnConf"
                 :loading="false">
        </m-table>
    </div>
</template>

<script>
import mTable from '@/components/otpPanel/mTable';

export class VdcTasksInfoTableController {
    _callbacks = new Map();

    setTasks (tasks) {
        this.fire('tasks', tasks);
    }

    fire (eventName, payload) {
        const callback = this._callbacks.get(eventName);
        if (callback) {
            callback(payload);
        }
    }

    listen (eventName, callback) {
        this._callbacks.set(eventName, callback);
    }

    unlisten () {
        this._callbacks = new Map();
    }
}

export default {
    name: 'vdc-tasks-info-table',
    components: { mTable },

    data () {
        return {
            totalData: []
        };
    },
    props: {
        mapId: String,
        tableColumnConf: String,
        controller: VdcTasksInfoTableController,
        config: Object
    },
    mounted () {
        this.controller.listen('tasks', (tasks) => {
            this.totalData = tasks;
        });
    },
    destroyed () {
        this.controller.unlisten();
    },
    computed: {
    },
    methods: {
    }
};
</script>

<style scoped lang="less">
.target-table {
    width: 100%;
    overflow-x: auto;
}
</style>
